<!--
/**
 * 骨架根容器组件 - SkeletonRoot
 *
 * 功能描述：
 * 1. 作为骨架组件容器，提供全局配置上下文
 *
 * Props
 * delay {Number} - [0] - 全局动画延迟基数（单位：100ms），子组件延迟基于此值计算
 *
 * Slots:
 * @slot default - 骨架组件插槽区域
 *
 * 使用示例:
 * <SkeletonRoot :delay="2">
 *   <Skeleton width="200px" />
 *   <Skeleton aspect-ratio="16/9" />
 * </SkeletonRoot>
 */
-->
<template>
  <div class="skeleton-root">
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  delay: {
    type: Number,
    default: 0
  }
})

provide('skeleton', {
  delay: props.delay
})
</script>

<style lang="less">
</style>
